import { Button, Toggle, Typography } from "@cur8/maneki";
import { useCallback } from "react";
import { useFeaturePreference } from "render/hooks/useFeaturePreference";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import styles from "./styles.module.sass";

interface FeatureFlagsViewProps {
  onBack(): void;
}

export function FeatureFlagsView({ onBack }: FeatureFlagsViewProps) {
  const featurePreferences = useFeaturePreference();

  const onToggleRoomScanWarning = useCallback(
    (isSelected: boolean) => {
      featurePreferences.set({
        ...featurePreferences.data,
        roomScanWarningEnabled: isSelected,
      });
    },
    [featurePreferences]
  );

  const onToggleNewCheckInFlow = useCallback(
    (isSelected: boolean) => {
      featurePreferences.set({
        ...featurePreferences.data,
        newCheckInFlowEnabled: isSelected,
      });
    },
    [featurePreferences]
  );

  return (
    <PageFrameContent>
      <div className={styles.FeatureFlagsView}>
        <Typography variant="display-s">Settings</Typography>

        <div className={styles.featureToggle}>
          <Toggle
            isSelected={featurePreferences.data.newCheckInFlowEnabled}
            onChange={onToggleNewCheckInFlow}
          />
          <div className={styles.text}>
            <Typography variant="label-m">New flow</Typography>
            <Typography variant="body-s">
              Add an identity verification step, manual measurements entry, and
              improved check-in flow.
            </Typography>
          </div>
        </div>

        <div className={styles.featureToggle}>
          <Toggle
            isSelected={featurePreferences.data.roomScanWarningEnabled}
            onChange={onToggleRoomScanWarning}
          />
          <div className={styles.text}>
            <Typography variant="label-m">Room scan warning</Typography>
            <Typography variant="body-s">
              Warn before assigning a room to a member when another member is
              actively being scanned in it.
            </Typography>
          </div>
        </div>
      </div>

      <ActionsFooter
        left={
          <Button variant="secondary" onPress={onBack} fillContainer>
            Back
          </Button>
        }
      />
    </PageFrameContent>
  );
}
